module.exports = __webpack_public_path__ + "static/img/logo.9ddd66a2.jpg";